export default "__VITE_ASSET__CqQnj6hn__"